import styled from 'styled-components';

import { colors, spacing, transition } from 'theme/theme';

export const PillHolder = styled.span`
  align-items: center;
  display: inline-flex;
  gap: ${spacing[8]};
  line-height: 1;
  transition: background ${transition};

  &[data-variant='default'] {
    background: ${colors.backgroundGrey};
    border: 1px solid ${colors.elementGrey};
    color: ${colors.lightContentGrey};
  }

  &[data-variant='outline'] {
    background-color: transparent;
    color: ${colors.lightContentGrey};

    border: 1px solid ${colors.selectionGrey};
  }

  &[data-size='small'] {
    font-size: 14px;
    border-radius: 20px;
    padding: ${spacing[8]} ${spacing[16]};
  }

  &[data-size='medium'] {
    font-size: 16px;
    line-height: 1.25;
    border-radius: 31px;
    padding: ${spacing[8]} ${spacing[16]};
  }

  &[data-size='large'] {
    font-size: 20px;
    line-height: 1.2;
    border-radius: 31px;
    padding: ${spacing[12]} ${spacing[24]};
  }

  &[data-clickable] {
    cursor: pointer;

    &:hover {
      background-color: ${colors.selectionBlue};
      color: ${colors.brandBlue};
    }
  }
`;

export const PillPrefixHolder = styled.span`
  display: flex;

  &:empty {
    display: none;
  }
`;

export const PillSuffixHolder = styled.span`
  display: flex;

  &:empty {
    display: none;
  }
`;

export const PillText = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const PillCloseButton = styled.button`
  border-radius: 50%;
  display: flex;
  line-height: inherit;
  color: ${colors.lightContentGrey};
  transition: all ${transition};

  &:hover {
    background-color: ${colors.selectionBlue};
    color: ${colors.brandBlue};
  }
`;
